const expandedClass = 'filter-expanded';
const collapsedClass = 'filter-collapsed';

export const initializeExpandableFilter = (expandFilterButton, expandableFilter) => {
    if (!expandFilterButton || !expandableFilter) {
        return;
    }

    expandFilterButton.addEventListener('click', () => {
        if (expandableFilter.classList.contains(collapsedClass)) {
            expandFilterMenu(expandableFilter);
        } else {
            collapseFilterMenu(expandableFilter);
        }
    });
}

export const expandFilterMenu = (expandableFilter) => {
    if (!expandableFilter) {
        return;
    }

    expandableFilter.classList.remove(collapsedClass);
    expandableFilter.classList.add(expandedClass);
}

const collapseFilterMenu = (expandableFilter) => {
    if (!expandableFilter) {
        return;
    }

    expandableFilter.classList.add(collapsedClass);
    expandableFilter.classList.remove(expandedClass);
}
